import { useEffect, useState } from 'react'
import { DateTime } from 'luxon'

// Refresh relative call dates at clinic midnight, including 23/25-hour DST days.
export const useClinicDay = (timeZone: string): string => {
  const zone = DateTime.now().setZone(timeZone).isValid ? timeZone : 'UTC'
  const [day, setDay] = useState(
    () => DateTime.now().setZone(zone).toISODate() ?? '',
  )
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>
    const refresh = (): void => {
      clearTimeout(timer)
      const now = DateTime.now().setZone(zone)
      setDay(now.toISODate() ?? '')
      timer = setTimeout(
        refresh,
        now.plus({ days: 1 }).startOf('day').toMillis() - now.toMillis() + 25,
      )
    }
    refresh()
    window.addEventListener('focus', refresh)
    return () => {
      clearTimeout(timer)
      window.removeEventListener('focus', refresh)
    }
  }, [zone])
  return day
}
